/** Runtime configuration from CRA env (`REACT_APP_*`). */
export const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? '',
  assetsBaseUrl: process.env.REACT_APP_ASSETS_BASE_URL ?? '',
  gtmId: process.env.REACT_APP_GTM_ID ?? '',
  /** Google Appointment Schedule booking page (calendar.app.google/…). */
  googleCalendarBookingUrl: process.env.REACT_APP_GOOGLE_CALENDAR_BOOKING_URL ?? '',
  /** Full embed URL (calendar.google.com/calendar/appointments/schedules/…). */
  googleCalendarEmbedUrl: process.env.REACT_APP_GOOGLE_CALENDAR_EMBED_URL ?? '',
  youtubeApiKey: process.env.REACT_APP_YOUTUBE_API_KEY ?? '',
  youtubeChannelId: process.env.REACT_APP_YOUTUBE_CHANNEL_ID ?? '',
  youtubeChannelVideosUrl: process.env.REACT_APP_YOUTUBE_CHANNEL_VIDEOS_URL ?? '',
  /** Product demo video (YouTube watch or embed URL). */
  productVideoUrl: process.env.REACT_APP_PRODUCT_VIDEO_URL ?? '',
  /** Google Apps Script web app URL for Get Started lead form submissions. */
  leadFormUrl: process.env.REACT_APP_LEAD_FORM_URL ?? '',
} as const;
